import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Test Results',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'implementationPullRequests',
                },
              },
              subqueries: {
                implementationPullRequests: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!type',
                          },
                          'IMPLEMENTATION',
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              { '`': { '``': { '@$': 'projectId' } } },
                              null,
                            ],
                          },
                          { '>': [{ '#': { '@': 'projectLinks' } }, 0] },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!pull_requests:!pull_request',
                  selection: {
                    '@.': '!id',
                  },
                  subqueries: {
                    projectLinks: {
                      ref: {
                        attr: 'attr:ent#!pr_req_links#!pr_req_link:!pull_request',
                      },
                      target: 'ent:!pr_req_links:!pr_req_link',
                      filter: {
                        '=': [
                          { '@': 'requirementProject' },
                          {
                            '@>': [
                              { '`': { '``': { '@$': 'projectId' } } },
                              'recordId',
                            ],
                          },
                        ],
                      },
                      selection: {
                        '@.': '!id',
                      },
                      subqueries: {
                        requirementProject: {
                          ref: {
                            attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
                          },
                          target: 'ent:!requirements:!requirement',
                          selection: {
                            '@': 'specProject',
                          },
                          subqueries: {
                            specProject: {
                              ref: {
                                attr: 'attr:ent#!requirements#!requirement:!spec',
                              },
                              target: 'ent:!specs:!spec',
                              selection: {
                                '@.': [
                                  '!project',
                                  { ref: { entity: '!proj' } },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!code',
                },
              },
              filter: {
                and: [
                  {
                    '=': [
                      {
                        '@.': '!type',
                      },
                      'IMPLEMENTATION',
                    ],
                  },
                  {
                    or: [
                      { '=': [{ '`': { '``': { '@$': 'projectId' } } }, null] },
                      { '>': [{ '#': { '@': 'projectLinks' } }, 0] },
                    ],
                  },
                ],
              },
              target: 'ent:!pull_requests:!pull_request',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      pullRequest: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      title: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      requirements: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'requirementLinks',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      testOutcome: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@': 'testOutcome',
                              },
                              'not run',
                            ],
                          },
                        },
                      },
                      passed: {
                        '{}': {
                          value: {
                            '@': 'testsPassed',
                          },
                        },
                      },
                      failed: {
                        '{}': {
                          value: {
                            '@': 'testsFailed',
                          },
                        },
                      },
                      skipped: {
                        '{}': {
                          value: {
                            '@': 'testsSkipped',
                          },
                        },
                      },
                      testedCommit: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@': 'testedCommitSha',
                              },
                              '—',
                            ],
                          },
                        },
                      },
                      deployOutcome: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@': 'deployOutcome',
                              },
                              'not deployed',
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                projectLinks: {
                  ref: {
                    attr: 'attr:ent#!pr_req_links#!pr_req_link:!pull_request',
                  },
                  target: 'ent:!pr_req_links:!pr_req_link',
                  filter: {
                    '=': [
                      { '@': 'requirementProject' },
                      {
                        '@>': [
                          { '`': { '``': { '@$': 'projectId' } } },
                          'recordId',
                        ],
                      },
                    ],
                  },
                  selection: {
                    '@.': '!id',
                  },
                  subqueries: {
                    requirementProject: {
                      ref: {
                        attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
                      },
                      target: 'ent:!requirements:!requirement',
                      selection: {
                        '@': 'specProject',
                      },
                      subqueries: {
                        specProject: {
                          ref: {
                            attr: 'attr:ent#!requirements#!requirement:!spec',
                          },
                          target: 'ent:!specs:!spec',
                          selection: {
                            '@.': ['!project', { ref: { entity: '!proj' } }],
                          },
                        },
                      },
                    },
                  },
                },
                requirementLinks: {
                  ref: {
                    attr: 'attr:ent#!pr_req_links#!pr_req_link:!pull_request',
                  },
                  target: 'ent:!pr_req_links:!pr_req_link',
                  selection: {
                    '@.': '!id',
                  },
                },
                testOutcome: {
                  ref: {
                    attr: 'attr:ent#!results#!result:!pull_request',
                  },
                  target: 'ent:!results:!result',
                  quantity: 1,
                  selection: {
                    '@.': '!test_outcome',
                  },
                },
                testsPassed: {
                  ref: {
                    attr: 'attr:ent#!results#!result:!pull_request',
                  },
                  target: 'ent:!results:!result',
                  quantity: 1,
                  selection: {
                    '@.': '!tests_passed',
                  },
                },
                testsFailed: {
                  ref: {
                    attr: 'attr:ent#!results#!result:!pull_request',
                  },
                  target: 'ent:!results:!result',
                  quantity: 1,
                  selection: {
                    '@.': '!tests_failed',
                  },
                },
                testsSkipped: {
                  ref: {
                    attr: 'attr:ent#!results#!result:!pull_request',
                  },
                  target: 'ent:!results:!result',
                  quantity: 1,
                  selection: {
                    '@.': '!tests_skipped',
                  },
                },
                testedCommitSha: {
                  ref: {
                    attr: 'attr:ent#!results#!result:!pull_request',
                  },
                  target: 'ent:!results:!result',
                  quantity: 1,
                  selection: {
                    '@.': '!tested_commit_sha',
                  },
                },
                deployOutcome: {
                  ref: {
                    attr: 'attr:ent#!results#!result:!pull_request',
                  },
                  target: 'ent:!results:!result',
                  quantity: 1,
                  selection: {
                    '@.': '!deploy_outcome',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'pullRequest',
                  direct: {
                    '{}': {
                      name: 'Pull Request',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'title',
                  direct: {
                    '{}': {
                      name: 'Title',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'requirements',
                  direct: {
                    '{}': {
                      name: 'Requirements',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'testOutcome',
                  direct: {
                    '{}': {
                      name: 'Test Outcome',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'passed',
                  direct: {
                    '{}': {
                      name: 'Passed',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'failed',
                  direct: {
                    '{}': {
                      name: 'Failed',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'skipped',
                  direct: {
                    '{}': {
                      name: 'Skipped',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'testedCommit',
                  direct: {
                    '{}': {
                      name: 'Tested Commit',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'deployOutcome',
                  direct: {
                    '{}': {
                      name: 'Deploy Outcome',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
